import { render, staticRenderFns } from "./wiki-revisions.vue?vue&type=template&id=14c4adcd"
import script from "./wiki-revisions.vue?vue&type=script&lang=js"
export * from "./wiki-revisions.vue?vue&type=script&lang=js"
import style0 from "./wiki-revisions.vue?vue&type=style&index=0&id=14c4adcd&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports